import React from 'react'


const VehicleLoadingUnloadingReportComponentLoadable = React.lazy(
  () => import("./VehicleLoadingUnloadingReport")
);
const NewVehicleLoadingUnloadingReportComponentLoadable = React.lazy(
  () => import("./VehicleLoadingUnloadingReportNew")
);
const VehicleHistoryReportComponentLoadable = React.lazy(
  () => import("./VehicleHistoryReport")
);

export {
  VehicleLoadingUnloadingReportComponentLoadable,
  VehicleHistoryReportComponentLoadable,
  NewVehicleLoadingUnloadingReportComponentLoadable
};
